import { Box, Typography } from "@material-ui/core"
import { FrontendEvent } from "common/types"
import { FunctionComponent } from "react"
import { StyledClock, StyledVideo, StyledDay } from "../styled"

interface SummitDateProps {
  event: FrontendEvent
  isDevice: Boolean
}

export const SummitDate: FunctionComponent<SummitDateProps> = ({ event, isDevice }) => {
  return (
    <>
      <Box display="flex" flexDirection={isDevice ? 'column' : 'row'}>
        <Box alignItems="center" mb="1em" display="flex" flexDirection="row">
          <StyledVideo />
          <Typography component="span" variant="caption">
            <Box ml="1em">
              {event?.metaData?.attendanceType || 'Virtual'}
            </Box>
          </Typography>
        </Box>
        <Box p={isDevice ? '0' : '0 1em'} display="flex" flexDirection="row">
          <StyledClock />
          <Typography component="span" gutterBottom variant="body1">
            <Box ml="1em">
              <StyledDay>{event?.date} - {event?.endDate}</StyledDay>
            </Box>
          </Typography>
        </Box>
      </Box>

    </>
  )
}